const rankings = [
  { rank: 1, title: '某社交平台大规模用户数据泄露事件内幕', views: '41.2万', trend: 'up', hot: true },
  { rank: 2, title: '圈内人爆料：某顶流综艺节目录制现场突发状况', views: '35.1万', trend: 'up', hot: true },
  { rank: 3, title: '某知名企业高管被曝内部不当行为，公司股价应声下跌', views: '28.6万', trend: 'up', hot: true },
  { rank: 4, title: '独家：某头部科技公司下一代产品路线图遭内部泄露', views: '22.3万', trend: 'stable', hot: false },
  { rank: 5, title: '内部邮件曝光：某大型金融机构风控存在重大漏洞', views: '19.8万', trend: 'up', hot: false },
  { rank: 6, title: '爆料：某二线城市即将出台重大楼市调控新政', views: '16.5万', trend: 'down', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-label font-semibold text-accent-600 uppercase tracking-wider">
            热度榜单
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2 mb-3">
            爆料热度榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            实时更新的51爆料网热门内容排行，每小时刷新
          </p>
        </div>

        <div className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-4 px-5 py-4 transition-colors cursor-pointer hover:bg-background-100 ${
                i < rankings.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-label text-sm font-bold shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-100 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  {item.hot && (
                    <span className="shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-600">
                      热门
                    </span>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-foreground-500">{item.views}</span>
                <i className={`text-sm ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                  item.trend === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                  'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}